import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormControlLabel, FormGroup } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import { Checkbox } from '@klp/design/Checkbox';

import { useKlpStyles } from '../../Theme/useKlpStyles';

import { useTableContext } from './TableContext';

const styles = (theme: Theme) => ({
    filterLeftPadding: {
        paddingLeft: theme.spacing(1),
    },
});

export const TableFilter: React.FC = () => {
    const { t } = useTranslation();
    const context = useTableContext();
    const classes = useKlpStyles({}, styles);
    return (
        <div className={classes.filterLeftPadding}>
            {(context.filter ?? []).length > 0 && (
                <FormControl component="fieldset">
                    {(context.filter ?? []).map((filterDef, filterDefIndex) => (
                        <FormGroup
                            key={`${filterDef.filterKey}-${filterDefIndex}`}
                            id={`filter${filterDef.filterKey}`}
                            row={true}
                        >
                            {Object.keys(filterDef.filterGroup).map(
                                (filterGroupName, filterGroupIndex) => (
                                    <FormControlLabel
                                        key={`${filterGroupName}-${filterGroupIndex}`}
                                        control={
                                            <Checkbox
                                                id={`filterControl${filterGroupName}`}
                                                checked={(
                                                    context.activeFilter ?? []
                                                ).includes(filterGroupName)}
                                                onChange={
                                                    context.handleChangeFilter
                                                        ? context.handleChangeFilter(
                                                              filterDef.filterKey,
                                                              filterGroupName,
                                                          )
                                                        : undefined
                                                }
                                                value={filterGroupName}
                                                klpPalette="secondary"
                                                data-testid={filterGroupName}
                                            />
                                        }
                                        label={
                                            <>
                                                {t(
                                                    filterDef.translations[
                                                        filterGroupName
                                                    ],
                                                )}

                                                {' ('}
                                                {
                                                    (
                                                        context.rawData ?? []
                                                    ).filter((entry) =>
                                                        filterDef.filterGroup[
                                                            filterGroupName
                                                        ].includes(
                                                            entry[
                                                                filterDef
                                                                    .filterKey
                                                            ],
                                                        ),
                                                    ).length
                                                }
                                                {') '}
                                            </>
                                        }
                                    />
                                ),
                            )}
                        </FormGroup>
                    ))}
                </FormControl>
            )}
        </div>
    );
};
